<template>
  <div>
    <div v-if="loading" class="ui active inverted dimmer loader-margin">
      <div class="ui text loader">{{ $t('loading') }}...</div>
    </div>
    <pageHeader :headerIcon="'recycle'"
                :headerText="$t('approvalRequests')"
                :haveFilterInput="false"
                :columnsNumber="['six wide column', 'three wide column', 'seven wide column']">
    </pageHeader>

    <abstractTable :columns="approvalRequestsColumns"
                   :data="computedApprovalRequests"
                    :classes="'ui tablet stackable very compact center aligned celled table'"
                    :dataPerPage="15" :paginationEnable="true"
                    style="margin-top: 60px !important;" :paginationNextButtonText="$t('next')"
                    :paginationPervButtonText="$t('previous')"
                    :paginationFirstPageButtonText="$t('first')"
                    :paginationLastPageButtonText="$t('last')">
        <template slot="table-column">
          <th> {{ $t('actions') }} </th>
        </template>
        <template slot="table-row-after" slot-scope="props">
          <td style="width: 12%">
            <div class="ui blue very compact mini icon button" style="background-color: #092442"
                  @click="navigateTo('Show_Approval_Request', { key: 'params', value: { id: props.row.id } })">
              <i class="file icon"></i>
            </div>
          </td>
        </template>
      </abstractTable>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default,
    pageHeader: require('@/components/abstract_components/PageHeader').default
  },
  data () {
    return {
      loading: true,
      approvalRequests: []
    }
  },
  mounted () {
    this.$http.get('approvals', {
      params: {
        clinic_id: this.getFromLocalStorage('clinicId')
      }
    }).then(response => {
      this.approvalRequests = response.data
      this.loading = false
    })
  },
  computed: {
    computedApprovalRequests () {
      let formlatedApprovalRequests = []

      window._.each(this.approvalRequests, approvalRequest => {
        formlatedApprovalRequests.push({
          id: approvalRequest.id,
          resource_type: approvalRequest.items[0].resource_type,
          action: approvalRequest.items[0].event,
          executed_at: approvalRequest.executed_at || approvalRequest.rejected_at || approvalRequest.cancelled_at
            ? window.moment(approvalRequest.executed_at || approvalRequest.rejected_at || approvalRequest.cancelled_at).format('DD/MM/YYYY hh:mm a') : '-',
          state: {
            value: `<p style="color: ${this.getColorName(approvalRequest)};">${approvalRequest.state}</p>`,
            filteredValue: approvalRequest.state
          },
          requested_at: window.moment(approvalRequest.requested_at).format('DD/MM/YYYY hh:mm a'),
          request_user: approvalRequest.request_user.name
        })
      })

      return formlatedApprovalRequests
    },
    approvalRequestsColumns () {
      return [
        { header: this.$t('id'), fieldName: 'id', show: true, width: '1%' },
        { header: 'Request User', fieldName: 'request_user', show: true },
        { header: this.$t('resourceType'), fieldName: 'resource_type', show: true },
        { header: this.$t('action'), fieldName: 'action', show: true },
        { header: this.$t('finishedAt'), fieldName: 'executed_at', show: true },
        { header: this.$t('state'), fieldName: 'state', show: true, html: true },
        { header: this.$t('requestedAt'), fieldName: 'requested_at', show: true }
      ]
    }
  },
  methods: {
    // this Function will be used in next merge request
    // cancelApprovalRequest (approvalRequest) {
    //   this.$http.post(`approvals/${approvalRequest.id}/cancel`, {
    //     clinic_id: this.getFromLocalStorage('clinicId')
    //   }).then(response => {
    //   })
    // },
    getColorName (approvalRequest) {
      if (approvalRequest.state === 'pending') {
        return '#f2711c'
      } else if (approvalRequest.state === 'cancelled') {
        return 'black'
      } else if (approvalRequest.state === 'rejected') {
        return '#db2828'
      } else {
        return '#21ba45'
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/approval_requests/ApprovalRequests.vue